import { createContext, useState } from "react";

const AuthContext = createContext({});

export const UserSummary = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [userSummary, setUserSummary] = useState({});
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("isLoggedIn")
  );

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        userSummary,
        setUserSummary,
        registerSuccess,
        setRegisterSuccess,
        isLoggedIn,
        setIsLoggedIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
